import { LocalesType } from "@shared/modules/navigation/types/navbar-types";
import { t } from "@shared/utils/internationalization";

export const navigationLocales: LocalesType = {
  en: {
    label: t("English"),
    shortLabel: "EN",
  },
  fr: {
    label: t("French"),
    shortLabel: "FR",
  },
};
